// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('order.deliveryPlanning', {
        url: '/deliveryplanning/{orderId}',
        templateUrl: 'main/order/orderdeliveryplanning/orderdeliveryplanning.tpl.html',
        controller: 'OrderDeliveryPlanningController as vm'
    });
}

function OrderDeliveryPlanningController($filter, $state, $stateParams, OrdersApiService, loadSpinnerService, ToasterService, OrderService){
    var vm = this;

    //Properties
    vm.orderId = $stateParams.orderId;
    vm.deliveryPlans = [];
    vm.deliveryPlansCopy;
    vm.selectedDeliveryPlanCopy = {};
    vm.comment = "";
    vm.isEditingPredicted = false;
    vm.isEditingConfirmed = false;
    vm.recalculate = false;
    vm.recalculatedDifference = 0;
    vm.approve = false;
    vm.showPlanned = true;

    //Methods
    vm.goBackToOrderView = goBackToOrderView;
    vm.formatDate = formatDate;
    vm.savePlan = savePlan;
    vm.undoPlan = undoPlan;
    vm.editSavedPlan = editSavedPlan;
    vm.getBackgroundColor = getBackgroundColor;
    vm.getPredictedBackgroundColor = getPredictedBackgroundColor;
    vm.getPredictedButtonBackgroundColor = getPredictedButtonBackgroundColor;
    vm.getConfirmedBackgroundColor = getConfirmedBackgroundColor;
    vm.saveMainComment = saveMainComment;
    vm.editingAny = editingAny;
    vm.editPredicted = editPredicted;
    vm.editConfirmed = editConfirmed;
    vm.doRecalculateDiffrence = doRecalculateDiffrence;
    vm.selectRow = selectRow;
    vm.showDifferece = showDifferece;
    vm.isSelected = isSelected;

    //Links
    vm.canConfirm = canConfirm;
    vm.canUndoConfirm = canUndoConfirm;
    vm.canChangePredicted = canChangePredicted;
    vm.isLeadTime = isLeadTime;

    //initMainComment()
    activate();

    function activate(){

        loadSpinnerService.start('mainSpinner');
        OrdersApiService.getById(vm.orderId).then(function(response) {
            vm.order = response.data.order;
            vm.comment = vm.order.mainComment;
            initMainComment();
            console.log(vm.order);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });

        reloadDeliveryPlan();
    }
    function initMainComment(){
        if(vm.order.mainComment == undefined){
            vm.comment = "";
        }
        else{
            vm.comment = vm.order.mainComment;
        }      
    }
    function saveMainComment(){
        var mainCommentData = {
            orderId: vm.orderId,
            mainComment: vm.comment
        };
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.saveMainComment(mainCommentData).then(function(response) {
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function reloadDeliveryPlan(){
        vm.recalculate = false;
        loadSpinnerService.start('mainSpinner');
        OrdersApiService.getOrderDeliveryPlan(vm.orderId).then(function(response) {
            vm.deliveryPlans = response.data.deliveryPlans;
            _.forEach(vm.deliveryPlans, function(plan){
                if(plan.confirmedDate === undefined)
                    plan.confirmedDate = null;
            });
            vm.deliveryPlansCopy = angular.copy(vm.deliveryPlans);
            console.log(vm.deliveryPlans);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});
        });
    }

    function doRecalculateDiffrence(plan){
        if(vm.recalculate){
            if(vm.isEditingPredicted)
                vm.recalculatedDifference = daysBetween(plan.predictedDate, vm.selectedDeliveryPlanCopy.predictedDate) * -1;
            else if(vm.isEditingConfirmed)
                vm.recalculatedDifference = daysBetween(plan.confirmedDate, vm.selectedDeliveryPlanCopy.predictedDate) * -1;
        }
    }

    function showDifferece(plan){
       return plan.index > vm.selectedDeliveryPlanCopy.index && vm.recalculate;
    }

    function treatAsUTC(date) {
        var result = new Date(date);
        result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
        return result;
    }
    
    function daysBetween(startDate, endDate) {
        var millisecondsPerDay = 24 * 60 * 60 * 1000;
        return (treatAsUTC(endDate) - treatAsUTC(startDate)) / millisecondsPerDay;
    }

    function goBackToOrderView(){
        $state.go("order.ordersearch", { orderId: vm.order.id });
    }

    function editingAny(){
        var isEdit = false;

        _.forEach(vm.deliveryPlansCopy, function(p){
            if(isSelected(p))
                isEdit = true;
        });

        return isEdit;
    }

    function isSelected(plan){
        if(vm.selectedDeliveryPlanCopy === {}) /// NO PLAN SELECTED
            return false;

        return vm.selectedDeliveryPlanCopy.id === plan.id;
    }

    function selectRow(plan){
        if(!isSelected(plan)){
            vm.selectedDeliveryPlanCopy = angular.copy(plan);
        }
    }

    function editPredicted(plan){
        console.log('succ');
        vm.selectedDeliveryPlanCopy = angular.copy(plan);
        vm.isEditingPredicted = true;
        plan.isEditing = true;
    }
    function editConfirmed(plan){
        console.log('succ');
        vm.selectedDeliveryPlanCopy = angular.copy(plan);
        vm.isEditingConfirmed = true;
        plan.isEditing = true;
        if(plan.confirmedDate === null)
            plan.confirmedDate = new Date();
    }
    function isLeadTime(plan){
        return OrderService.isLeadTimeDeliveryPlan(plan.links);
    } 

    function canConfirm(plan){
        return OrderService.canConfirmDeliveryPlan(plan.links);
    }
    function canUndoConfirm(plan){
        return OrderService.canUndoConfirmDeliveryPlan(plan.links);
    }
    function canChangePredicted(plan){
        return OrderService.canChangePredictedDate(plan.links);
    }

    function savePlan(plan){
        console.log(plan.predictedDate);
        vm.isEditingPredicted = false;
        vm.isEditingConfirmed = false;
        plan.isEditing = false;
        vm.recalculatedDifference = 0;

        loadSpinnerService.start('mainSpinner');
        OrdersApiService.saveOrderDeliveryPlan(plan, vm.orderId, vm.recalculate).then(function(response) {
            ToasterService.showSuccess(response.message);
        }, function(error){
            ToasterService.showError(error.message);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', {force: true});

            reloadDeliveryPlan();
            vm.selectedDeliveryPlanCopy = {};
        });
    }
    function undoPlan(plan){
        vm.isEditingPredicted = false;
        vm.isEditingConfirmed = false;
        vm.recalculatedDifference = 0;

        reloadDeliveryPlan();
        vm.selectedDeliveryPlanCopy = {};
    }

    function editSavedPlan(plan){
        console.log(plan);
        selectRow(plan);
        plan.completed = false;
    }

    function formatDate(date) {
        if(date === null)
            return date;
        if(angular.isNumber(date)){
            date = new Date(date);
        }
        const offset = date.getTimezoneOffset()
        date = new Date(date.getTime() - (offset*60*1000))
        return date.toISOString().split('T')[0]
    }

    function getBackgroundColor(plan){
        var style = {};

        //if(plan.completed){
        //    if(plan.index % 2 == 0)
        //        style['background-color'] = 'rgb(235, 255, 235)';
        //    else
        //        style['background-color'] = 'rgb(225, 245, 225)';
        //}
        if(plan.index % 2 == 0)
            style['background-color'] = 'rgb(255, 255, 255)';
        else
            style['background-color'] = 'rgb(245, 245, 245)';

        if(isSelected(plan)){
            style['background-color'] = 'lightyellow';
        } 
        return style;
    }

    function getPredictedBackgroundColor(plan){
        var style = {};

        if(vm.isLeadTime(plan)){
            if(daysBetween(plan.plannedDate, plan.predictedDate) > 0 && !isSelected(plan)){
                if(plan.index % 2 == 0)
                    style['background-color'] = 'rgb(255, 225, 225)';
                else
                    style['background-color'] = 'rgb(235, 215, 215)';
            }
            else if(daysBetween(plan.plannedDate, plan.predictedDate) < 0 && !isSelected(plan)){
                if(plan.index % 2 == 0)
                    style['background-color'] = 'rgb(225, 255, 225)';
                else
                    style['background-color'] = 'rgb(215, 235, 215)';
            }
        }

        return style;
    }
    function getPredictedButtonBackgroundColor(plan){
        var style = {};

        if(daysBetween(plan.plannedDate, plan.predictedDate) > 0 && !isSelected(plan)){
            style['background-color'] = 'rgb(255, 245, 245)';
        }

        return style;
    }
    function getConfirmedBackgroundColor(plan){
        var style = {};

        if(vm.isLeadTime(plan)){
            if(daysBetween(plan.predictedDate, plan.confirmedDate) > 0 && !isSelected(plan)){
                if(plan.index % 2 == 0)
                    style['background-color'] = 'rgb(255, 225, 225)';
                else
                    style['background-color'] = 'rgb(235, 215, 215)';
            }
            else if(daysBetween(plan.predictedDate, plan.confirmedDate) <= 0 && !isSelected(plan)){
                if(plan.index % 2 == 0)
                    style['background-color'] = 'rgb(225, 255, 225)';
                else
                    style['background-color'] = 'rgb(215, 235, 215)';
            }
        }
        else if(plan.completed){
            if(plan.index % 2 == 0)
                style['background-color'] = 'rgb(225, 255, 225)';
            else
                style['background-color'] = 'rgb(215, 235, 215)';
        }

        return style;
    }
}

angular
.module('order.deliveryPlanning', [])
.config(stateConfig)
.controller('OrderDeliveryPlanningController', OrderDeliveryPlanningController);